import React, { FC } from 'react';

import useParamHotelId from '../../../hooks/router/params/useParamHotelId';

import useCanAccessChatbotLulu from '../../../hooks/useCanAccessChatbotLulu';
import useLogout from '../../../hooks/useLogout';
import translate from '../../../i18n/translate';
import MobileFullViewNavigation from '../../MUI/MobileFullViewNavigation';

import { NavigationListButtonProps } from '../../MUI/MobileFullViewNavigation/NavigationListButton';

import { generateLinks } from './links';

export type Props = {
  nrHotels: number;
};

/**
 * Profile menu for the mobile screens
 *
 * @param props          Props passed to the component
 * @param props.nrHotels The number of hotels the user has access to
 * @returns              MobileNavigation component
 */
const MoreNavigationMobile: FC<Props> = ({ nrHotels }) => {
  const hotelId = useParamHotelId();
  const logout = useLogout();
  const canAccessChatbotLulu = useCanAccessChatbotLulu();

  const links = generateLinks(hotelId, nrHotels, canAccessChatbotLulu);

  const buttonLogout: NavigationListButtonProps = {
    icon: 'logout',
    isDisabled: false,
    label: translate('GENERAL__LOGOUT'),
    onClick: logout,
  };

  return <MobileFullViewNavigation buttons={[buttonLogout]} links={links} />;
};

export default MoreNavigationMobile;
